import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, LockKeyhole } from "lucide-react";
import "./AccessRestrictedPage.css";

// Presentation only. The route guard supplies the decision and owns all actions.
export default function AccessRestrictedPage({ organizationName, homePath = "/", title,
  description, areaLabel, accountLabel, roleLabel, onSwitchAccount, onRetry }) {
  return (
    <div className="access-restricted-page">
      <header className="access-restricted__header">
        <span className="access-restricted__brand" title={organizationName || "Your organization"}>
          {organizationName || "Your organization"}
        </span>
        <Link to={homePath} className="access-restricted__home">Organization home</Link>
      </header>
      <main className="access-restricted__main">
        <section className="access-restricted__card" aria-labelledby="access-restricted-title">
          <div className="access-restricted__icon" aria-hidden="true"><LockKeyhole size={25} strokeWidth={1.7} /></div>
          <h1 id="access-restricted-title">{title}</h1>
          <p className="access-restricted__area">{areaLabel}</p>
          <p className="access-restricted__description">{description}</p>
          <div className="access-restricted__account">
            <span className="access-restricted__label">Signed in as</span>
            <div className="access-restricted__identity">
              <span className="access-restricted__email">{accountLabel}</span>
              <span className="access-restricted__role">{roleLabel}</span>
            </div>
          </div>
          <Link to={homePath} className="access-restricted__primary">
            <ArrowLeft size={18} aria-hidden="true" />Back to organization
          </Link>
          <div className="access-restricted__secondary">
            <button type="button" onClick={onSwitchAccount} aria-describedby="access-switch-note">Switch account</button>
            <button type="button" onClick={onRetry}>Check access again</button>
          </div>
          <p id="access-switch-note" className="access-restricted__note">Switching accounts will sign you out.</p>
          <p className="sr-only">Your requested page is preserved when switching accounts.</p>
        </section>
      </main>
    </div>
  );
}
